import { computed, ref } from 'vue'

import type { Ref, ComputedRef } from 'vue'
import type { MultiselectSearchOption } from '@shared/ui/fields'
import type { ExtraFieldName } from '@shared/model'

import { useListsStore } from '@shared/model'

interface FilterExtraFieldOptions {
  name: ExtraFieldName
  initial: string[]
}

export interface FilterExtraFieldReturn {
  options: ComputedRef<MultiselectSearchOption[]>
  query: Ref<string[]>
  initialValue: ComputedRef<string[]>
  handleSelected: (selected: MultiselectSearchOption[]) => void
}

export const useFilterExtraField = ({ name, initial }: FilterExtraFieldOptions): FilterExtraFieldReturn => {
  const listsStore = useListsStore()

  const query = ref<string[]>(initial)

  const options = computed<MultiselectSearchOption[]>(() => {
    const values = listsStore.getExtraFields?.[name]?.values ?? []

    return values.map((option) => {
      const value = String(option.value)

      return {
        id: value,
        value,
        text: option.text,
        selected: query.value.includes(value),
      }
    })
  })

  const initialValue = computed<string[]>(() => {
    return options.value
      .filter(option => option.selected)
      .map(option => option.text)
  })

  const handleSelected = (selected: MultiselectSearchOption[]): void => {
    const isAll = selected.length === options.value.length
    query.value = isAll ? [] : selected.map(option => String(option.value))
  }

  return {
    options,
    query,
    initialValue,
    handleSelected,
  }
}
